import React, { createContext, useState, useEffect, useContext } from "react";

// Create a context for profiles
export const ProfileContext = createContext();

// Profile provider to manage profiles globally
export const ProfileProvider = ({ children }) => {
  const [profiles, setProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(""); // Track the selected profile

  useEffect(() => {
    const storedProfiles = localStorage.getItem("profiles");
    if (storedProfiles) {
      setProfiles(JSON.parse(storedProfiles));
    }
  }, []);

  useEffect(() => {
    const storedSelectedProfile = localStorage.getItem("selectedProfile");
    if (storedSelectedProfile) {
      setSelectedProfile(storedSelectedProfile);
    }
  }, []);

  const addProfile = (profile) => {
    const updatedProfiles = [...profiles, profile];
    setProfiles(updatedProfiles);
    localStorage.setItem("profiles", JSON.stringify(updatedProfiles));
  };

  const deleteProfile = (profileValue) => {
    const updatedProfiles = profiles.filter(
      (profile) => profile.value !== profileValue
    );
    setProfiles(updatedProfiles);
    localStorage.setItem("profiles", JSON.stringify(updatedProfiles));
  };

  const handleProfileSelection = (profileValue) => {
    setSelectedProfile(profileValue);
    localStorage.setItem("selectedProfile", profileValue); // Save the selected profile in local storage
    console.log(`Profile selected: ${profileValue}`);
  };

  return (
    <ProfileContext.Provider
      value={{
        profiles,
        setProfiles,
        selectedProfile,
        setSelectedProfile,
        addProfile,
        deleteProfile,
        handleProfileSelection, // Include the function here
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfileContext = () => useContext(ProfileContext);
